import TopTrends from './TopTrends';
import TopTrendsTable from "./TopTrendsTable"
import TopTrendsControls from "./TopTrendsControls";
import FooterContent from "./FooterContent";
import './TopTrends.scss';
import './TopTrendsTable.scss';
import './TopTrendsControls.scss';

export type { CategoryItem } from "./TopTrendsControls";
export { TopTrendsControls, FooterContent, TopTrendsTable };
export default TopTrends;
